import { number, object, string } from "yup";

export const creditNoteSchema = () =>
  object({
    postedDate: string().required("Creation date is required"),
    creditAmount: number()
      .min(0.01, "Amount must be greater than 0")
      .required("Credit amount is required"),
    description: string().required("Description is required"),
  });
